import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
@Component({
  selector: 'app-person-internal-id',
  templateUrl: './person-internal-id.component.html',
  styleUrls: ['./person-internal-id.component.scss']
})
export class PersonInternalIdComponent implements OnInit {

  noDataMsg = Constants.DATA_NOT_AVAIL_UI;
  idMappingArr: any[] = [];

  // CCR1-11583 Display Person Internal IDs
  constructor(private dialogRef: MatDialogRef<PersonInternalIdComponent>, public rootScope: RootScopeService) {
    this.displayPersonInternalIdData();
  }

  ngOnInit(): void {

  }

  modalClose(): void {
    this.dialogRef.close();
  }

  displayPersonInternalIdData() {

    if (
      !this.rootScope.activeCustTab ||
      !this.rootScope.activeCustTab.tabData ||
      !this.rootScope.activeCustTab.tabData.tabData
    ) {
      console.warn('PersonInternalIdComponent: Missing activeCustTab or required properties.');
      return;
    }
    // Directly using idMappingArr from tabData.tabData
    this.idMappingArr = this.rootScope.activeCustTab.tabData.tabData?.idMapping || [];
  }



  showRoleTypeInFullForm(roleType) {
    if (this.rootScope.roleTypeListForPlatFormInternalIdTable[roleType]) {
      return this.rootScope.roleTypeListForPlatFormInternalIdTable[roleType];
    }
    return roleType;
  }

}
